import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import EnhancedTable from '../../../../../../../../../../../../../lib/designSystem/Table';
import { replaceInvoice } from '../../../../../../../../../../../../../lib/api/factoring';
import { showAlert } from '../../../../../../../../../../../../../lib/functions/utils';
import CenteredCircularProgress from '../../../../../../../../../../../../../lib/designSystem/CircularProgress';

export const ReplacementDialog = (props: any) => {
  const {
    openSelectReplacementInvoice,
    setOpenSelectReplacementInvoice,
    replacementInvoices,
    documentToReplace,
    selectedRequest,
    setUp,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedReplacementInvoice, setSelectedReplacementInvoice] =
    useState<any>([]);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);

  const cantSelectRow = (row: any) => {
    if (row.id === selectedReplacementInvoice[0]) {
      return false;
    }
    return selectedReplacementInvoice.length >= 1;
  };

  const handleApply = () => {
    if (selectedReplacementInvoice.length === 1) {
      const invoice = replacementInvoices.find(
        (x: any) => x.id === selectedReplacementInvoice[0],
      );
      setSelectedInvoice(invoice);
      setOpenConfirmationDialog(true);
    }
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await replaceInvoice(
        dispatch,
        {
          invoiceId: selectedInvoice.id,
        },
        documentToReplace.id,
      );
      showAlert(dispatch, 'success', 'Factura reemplazada correctamente');
      setOpenSelectReplacementInvoice(false);
      setUp(selectedRequest.id);
    } catch (error) {
      console.log(error);
      showAlert(dispatch, 'error', 'Error al reemplazar la factura');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={openSelectReplacementInvoice}>
      <DialogTitle>
        Selecciona una factura de reemplazo para el folio{' '}
        {documentToReplace.folio}
      </DialogTitle>
      <DialogContent>
        {!openConfirmationDialog ? (
          <EnhancedTable
            dataHeaders={[
              {
                key: 'folio',
                label: 'Folio',
              },
              {
                key: 'amount',
                label: 'Monto',
              },
              {
                key: 'businessIdentifier',
                label: 'Rut cliente',
              },
              {
                key: 'stakeholderIdentifier',
                label: 'Rut deudor',
              },
            ]}
            data={replacementInvoices}
            cantSelectRow={cantSelectRow}
            selected={selectedReplacementInvoice}
            setSelected={setSelectedReplacementInvoice}
          />
        ) : (
          <div>
            <Typography variant="body1">
              Estás a punto de reemplazar la factura {documentToReplace.folio}{' '}
              con la factura {selectedInvoice.folio}.
            </Typography>
            {loading && <CenteredCircularProgress type="dialog" />}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton
          color="secondary"
          onClick={() => setOpenSelectReplacementInvoice(false)}
        >
          Cancelar
        </CustomButton>
        {!openConfirmationDialog && (
          <CustomButton
            disabled={selectedReplacementInvoice.length !== 1}
            onClick={handleApply}
          >
            Reemplazar
          </CustomButton>
        )}
        {openConfirmationDialog && (
          <CustomButton onClick={handleConfirm}>Confirmar</CustomButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ReplacementDialog;
